export enum DonationChannel {
  TWILIO_PRIORITY = 'twilio_priority',
  TWILIO_FLEX_PRIORITY = 'twilio_flex_priority',
  DONOR_APP_PRIORITY = 'donor_app_priority',
  DONOR_APP_V2_PRIORITY = 'donor_app_v2_priority',
  DONOR_APP_V2_STANDARD = 'donor_app_v2_standard',
}
